import { ADMIN_PATHS } from './paths.ts';

export { ADMIN_PATHS };

export const ADMIN_ROUTE_TITLES: Record<string, string> = {
  [ADMIN_PATHS.DASHBOARD]: 'Dashboard',
  [ADMIN_PATHS.ROOT]: 'Dashboard',
  [ADMIN_PATHS.ORGANIZATIONS]: 'Organizations',
  [ADMIN_PATHS.USERS]: 'Users',
  [ADMIN_PATHS.INTEGRATIONS]: 'Integrations',
  [ADMIN_PATHS.INTEGRATION_TYPES]: 'Integration Types',
  [ADMIN_PATHS.ROLE_ACCESS]: 'Role Access',
  [ADMIN_PATHS.AUDIT_LOG]: 'Audit Log',
  [ADMIN_PATHS.SOP_VIDEOS]: 'SOP Videos',
  [ADMIN_PATHS.AI_USAGE]: 'AI Usage',
  [ADMIN_PATHS.MODEL_COMPARE]: 'Model Compare',
};

export const ADMIN_SEGMENT_LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  organizations: 'Organizations',
  organization: 'Organization',
  users: 'Users',
  user: 'User',
  integrations: 'Integrations',
  'integration-types': 'Integration Types',
  'role-access': 'Role Access',
  'audit-log': 'Audit Log',
  'sop-videos': 'SOP Videos',
  'ai-usage': 'AI Usage',
  'model-compare': 'Model Compare',
};
